<template>
    <div>
        <label class="sg-textfield-label">
            <span class="sg-textfield-label-caption" v-html="$t('general.currency')"></span>
        </label>
        <vrm-dropdown
            :value="mappedValue"
            :search-enabled="true"
            :options="currencies"
            @input="onInput"
        />
    </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';
import VrmDropdown from '@/vue/components/shared/VrmDropdown.vue';
import { CURRENCIES } from '@/vue/store/modules/currencies';

@Component({
    components: { VrmDropdown },
})
@AngularDirective('vrm-currency-dropdown')
export default class VrmCurrencyDropdown extends Vue {
    @Prop({ default: null })
    value;
    @ngInject()
    ApiService;

    created() {
        if (this.$store.getters[CURRENCIES.GET_ALL] === null) this.fetchCurrencies();
    }

    fetchCurrencies() {
        this.ApiService.call('/currencies', {}, 'GET', false, 'json', false).then(response => {
            let currencies = [];
            if (response.data && Array.isArray(response.data.records)) {
                currencies = response.data.records;
            }
            this.$store.commit(CURRENCIES.SET_ALL, currencies);
        });
    }

    onInput(e) {
        this.$emit('input', this.$store.getters[CURRENCIES.GET_BY_ID](e.id));
    }

    formatOption(value) {
        if (!value) return null;
        return {
            id: value.idCurrency,
            name: `${value.name} - ${value.sign} (${value.code})`,
        };
    }

    get mappedValue() {
        return this.formatOption(this.value);
    }

    get currencies() {
        return (this.$store.getters[CURRENCIES.GET_ALL] || []).map(this.formatOption);
    }
}
</script>

<style scoped lang="scss"></style>
